export const connectionsStyle = (template) => {
  if (template && template.interaction.connections) {
    return {
      background: template.interaction.connections.background,
      borderRadius: template.interaction.connections.borderRadius,
      borderWidth: template.interaction.connections.borderWidth,
      borderColor:
        template.interaction.connections.borderColor != "unset"
          ? template.interaction.connections.borderColor
          : "transparent",
      borderStyle:
        template.interaction.connections.borderWidth != "unset"
          ? "solid"
          : undefined,
      fontSize: template.interaction.connections.fontSize,
      fontWeight: template.interaction.connections.fontWeight,
      fontFamily: template.interaction.connections.fontFamily,
      color: template.interaction.connections.color,
    };
  } else {
    return {
      ...template.label,
      background: template.content ? template.content.backgroundColor : "#fff",
    };
  }
};
